//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { venues_list, playingField_list, playingField_changeStatus, playingField_del } from '@/apis/stadium'
import { sportType_list } from '@/apis/config'
import columns from './columns.js'


export default {
    data() {
        return {
            config: {
                //運動類型
                motions: [],
                //所屬場館
                gymnasiums: []
            },
            form: {
                fieldName: '',
                venueCode: '',
                status: '',
                sportTypeCode: '',
            },
            loading: false,
            //table data
            data: [],
            //table columns
            columns: [],
            pagination: {
                current: 1,
                pageSize: 10,
                total: 0
            }
        }
    },
    created() {
        this.columns.push({ title: '場地名稱', dataIndex: 'fieldCode', key: 'fieldCode', });
        this.columns.push({ title: '場地名稱', dataIndex: 'fieldName', key: 'fieldName', });
        this.columns.push({ title: '場地類型', dataIndex: 'sportName', key: 'sportName' });
        this.columns.push({ title: '所屬場館', dataIndex: 'venueName', key: 'venueName', });
        this.columns.push({ title: '場地狀態', dataIndex: 'status', key: 'status', width: 150, scopedSlots: { customRender: 'status' }, });
        this.columns.push({ title: '添加時間', dataIndex: 'createdTime', key: 'createdTime', width: 180, });
        this.columns.push({ title: '操作', key: 'operation', width: 330, scopedSlots: { customRender: 'action' }, });
    },
    mounted() {
        this.$nextTick(async () => {
            await this.onPageConfig();
            await this.onPageLoad();
        });
    },
    methods: {
        async onPageConfig() {
            try {
                //加載運動類型
                const res = await sportType_list({ typeCode: '', name: '', pageSize: 99, pageNumber: 1 });
                this.config.motions = res.data.records;
                //加載所屬場館
                const res2 = await venues_list({ venueName: '', venueCode: '', venueState: '1', pageNumber: 1, pageSize: 999 });
                this.config.gymnasiums = res2.data.records;
            } catch (error) {
                this.$message.error(error.message);
            }
        },
        async onPageLoad(isPostBack) {
            if (this.loading) return;
            if (!isPostBack) {
                this.pagination.current = 1;
            }
            try {
                this.loading = true;

                const res = await playingField_list({
                    ...this.form,
                    pageNumber: this.pagination.current,
                    pageSize: this.pagination.pageSize
                }) || {};
                if (res.code == 0) {
                    const data = res.data || {};
                    this.data = data.records;
                    this.pagination.total = data.total;
                } else {
                    if (res.msg)
                        throw new Error(res.msg);
                }

            } catch (error) {
                console.log(error);
                this.$message.error(error.message);
            } finally {
                this.loading = false;
            }
        },
        //獲取運動類型名稱
        getSportTypeName(code) {
            if (code && this.config.motions) {
                const data = this.config.motions.filter(item => item.typeCode == code);
                if (data && data.length > 0) {
                    return data[0].name
                }
            }
            return code;
        },
        /* 頁面事件鉤子 */
        handleSearchSubmit(e) {
            e.preventDefault();
            this.onPageLoad(true);
        },
        handleTableChange(pagination, filters, sorter) {
            this.pagination.current = pagination.current;
            this.onPageLoad(true);
        },
        async handleRowEditStatus(item, status) {
            //edit status
            try {
                const res = await playingField_changeStatus(item.id, status);
                if (res.code == 0) {
                    this.onPageLoad(true);
                } else {
                    this.$message.error(res.msg);
                }
            } catch (error) {
                this.$message.error(error.message);
            }
        },
        //刪除行
        async handleRowDelete(item) {
            try {
                const res = await playingField_del(item.id);
                if (res.code == 0) {
                    this.onPageLoad();
                } else {
                    this.$message.error(res.msg);
                }
            } catch (error) {
                this.$message.error(error.message);
            }
        },
        handleToDetails(id) {
            this.$router.push(`/stadium/${id}`);
        },
        handleToInstall() {
            this.$router.push(`/stadium/form`);
        },
        handleToEdit(id) {
            this.$router.push(`/stadium/form/${id}`);
        }
    }
}
